import Box from 'app/components/base/Box'
import Container from 'app/components/base/Container'
import Skeleton from 'app/components/base/Skeleton'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import Breadcrumbs from 'app/components/common/Breadcrumbs'

import useGenerateBreadcrumbsAndTitle from './hooks/useGenerateBreadcrumbsAndTitle'

interface BreadcrumbsBlockProps {
  categorySlug: string
  subcategorySlug?: string
  isLoading?: boolean
  isMultipleCategories?: boolean
  articleTitle?: string
}

const BreadcrumbsBlock = ({
  categorySlug,
  isLoading,
  articleTitle,
  isMultipleCategories
}: BreadcrumbsBlockProps) => {
  const { breadcrumbsItems, title } = useGenerateBreadcrumbsAndTitle({
    categorySlug,
    articleTitle,
    isMultipleCategories
  })

  return (
    <Box sx={{ backgroundColor: 'background.dark' }}>
      <Container maxWidth="md" sx={{ py: { xs: 3, md: 5 } }}>
        <Stack direction="column" spacing={1}>
          <Breadcrumbs items={breadcrumbsItems} />

          <Skeleton
            loading={isLoading}
            sx={{ width: { xs: '50%', md: '30%' }, height: { xs: 24, md: 35 } }}
          >
            <Text variant="h2" size={{ xs: 'h3', md: 'h2' }}>
              {title}
            </Text>
          </Skeleton>
        </Stack>
      </Container>
    </Box>
  )
}

export default BreadcrumbsBlock
